import {
    useQuery
  } from 'react-query'
import { getUserTestList, getOpenTradeOrdersList, getTradeList, MetaDataList } from '../api/api'


  function useUserList(token:any){
    return useQuery(
        ['fetch-user-list', token],
        () => getUserTestList(token),
        {
            keepPreviousData: true,
            refetchOnWindowFocus: false,
        }
    )
  }

  function useFetchOpenTradeOrders( token:any){
    return useQuery(
        ['fetch-trade-orders', "2022-06-01", 
        "2023-12-31",  token],
        () => getOpenTradeOrdersList("2022-06-01", 
        "2023-12-31",  token),
        {
            keepPreviousData: true,
            refetchOnWindowFocus: false,
        }
    )
  }
  function useFetchTradeList( token:any){
    return useQuery(
        ['fetch-open-orders', "2022-06-01", 
        "2023-12-31",  token],
        () => getTradeList("2022-06-01", 
        "2023-12-31",  token),
        {
            keepPreviousData: true,
            refetchOnWindowFocus: false,
        }
    )
  }

  function useGetMetadataList(token: any) {
    return useQuery(
      ["fetch-MetaList", token],
      () => MetaDataList(token),
      {
        keepPreviousData: true,
        refetchOnWindowFocus: false,
      }
    );
  }
  

  export { useUserList, useFetchOpenTradeOrders, useFetchTradeList, useGetMetadataList }